import {
	GridActionsCellItem,
	GridActionsCellItemProps,
	GridRowParams,
} from '@innovyze/stylovyze';

import AddCircleIcon from '@mui/icons-material/AddCircle';
import React from 'react';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { useFilters } from '../../useFilters';
import { removeExcludedFilter } from '../../../utils/filter';
import { useGlobalization } from '../../../../../i18n/useGlobalization';

export enum GridMenuItems {
	exclude = 'exclude',
}

export const allGridMenuItems = Object.values(GridMenuItems);

export type ShowInMenu = GridMenuItems[];

type CustomActionProps = Omit<GridActionsCellItemProps, 'label'> & {
	assetId: string;
};

const IncludeAction = ({
	assetId,
	...props
}: CustomActionProps): React.ReactElement<GridActionsCellItemProps> => {
	const { t } = useGlobalization();
	const { removeExcludedItem } = useFilters();

	return (
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		<GridActionsCellItem
			{...(props as any)}
			icon={<AddCircleIcon />}
			label={t('Include asset in filter') ?? ''}
			onClick={() => {
				removeExcludedItem(assetId);
			}}
		/>
	);
};

const RemoveAction = ({
	assetId,
	...props
}: CustomActionProps): React.ReactElement<GridActionsCellItemProps> => {
	const { t } = useGlobalization();
	const { rawFilter, addExcludedItem } = useFilters();

	return (
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		<GridActionsCellItem
			{...(props as any)}
			icon={<RemoveCircleIcon />}
			label={t('Remove asset from filter') ?? ''}
			onClick={() => {
				addExcludedItem(assetId);
			}}
			disabled={removeExcludedFilter(rawFilter).items.length === 0}
		/>
	);
};

export const getActions = (showInMenu: ShowInMenu) => (
	params: GridRowParams,
): React.ReactElement<GridActionsCellItemProps>[] => {
	const actions: React.ReactElement<GridActionsCellItemProps>[] = [];

	if (showInMenu.includes(GridMenuItems.exclude)) {
		const isExcluded = params.row.excluded;
		if (isExcluded) {
			// NB: showInMenu has to be added here otherwise the action option will show in the column instead of in the menu
			actions.push(<IncludeAction assetId={params.row._id} showInMenu />);
		} else {
			actions.push(<RemoveAction assetId={params.row._id} showInMenu />);
		}
	}

	return actions;
};
